import React from 'react';
import { MainLayoutSwitcher } from '../../../_layouts';
import { HeaderSection } from '../../../_sections/Header';
import { Composition } from '../../../types/api/Composition';

type Frameless = {
  composition: Composition;
};
export function Frameless({ composition }: Frameless) {
  return (
    <>
      {composition.sections.header && <HeaderSection {...composition.sections.header} />}
      <div className="frameless">
        <div className="frameless__container">
          <div className="content">
            <MainLayoutSwitcher
              layout={composition.layout}
              contentSection={composition.sections.content}
              contextSection={composition.sections.context}
            />
          </div>
        </div>
      </div>
    </>
  );
}
